import { render, staticRenderFns } from "./applyDeliver.vue?vue&type=template&id=13f8808b&scoped=true"
import script from "./applyDeliver.vue?vue&type=script&lang=js"
export * from "./applyDeliver.vue?vue&type=script&lang=js"
import style0 from "./applyDeliver.vue?vue&type=style&index=0&id=13f8808b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f8808b",
  null
  
)

export default component.exports